import { Gamepad2, MessageCircle, Swords, Trophy } from 'lucide-react';
import { DiamondIcon } from './DiamondIcon.js';

/** Player intent order: immediate play, long-term progress, competition, commerce. */
export const primaryNavigationItems = [
  { to: '/', label: 'Играть', icon: Gamepad2, tone: 'play' },
  { to: '/duels', label: 'Дуэли', icon: Swords, tone: 'duels' },
  { to: '/leaders', label: 'Рейтинг', icon: Trophy, tone: 'rating' },
  { to: '/chat', label: 'Чат', icon: MessageCircle, tone: 'chat' },
  { to: '/store', label: 'Магазин', icon: DiamondIcon, tone: 'store' },
] as const;
